import { render, staticRenderFns } from "./biddingView.vue?vue&type=template&id=3f6ba80f&scoped=true"
import script from "./biddingView.vue?vue&type=script&lang=js"
export * from "./biddingView.vue?vue&type=script&lang=js"
import style0 from "./biddingView.vue?vue&type=style&index=0&id=3f6ba80f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ba80f",
  null
  
)

export default component.exports